<div class="nav-side-menu">
  <fa-icon
    class="fa fa-bars fa-2x toggle-btn"
    [icon]="faBars"
    data-bs-toggle="collapse"
    href="#menu-content"
  >
  </fa-icon>
  <nav class="menu-list">
    <ul id="menu-content" class="menu-content collapse out">
      <li
        *ngIf="canViewMonitor()"
        data-bs-toggle="collapse"
        href="#service"
        class="collapsed"
      >
        <a>
          <fa-icon [icon]="faGlobe"></fa-icon> Monitor
          <!-- <span class="teste"><fa-icon [icon]="faChevronRight"></fa-icon></span> -->
        </a>
      </li>
      <ul class="sub-menu collapse" id="service">
        <li
          *ngIf="
            !canShowGroup([
              groups.DistribuidorMaster || groups.DistribuidorBoleta
            ])
          "
          [routerLinkActive]="['active']"
          [routerLink]="['/status']"
        >
          <a>Status</a>
        </li>

        <li [routerLinkActive]="['active']" [routerLink]="['/todos']">
          <a>Todos</a>
        </li>
        <li
          [routerLinkActive]="['active']"
          [routerLink]="['/painel-pendencia-atuacao']"
        >
          <a>Painel de Pendências e Atuações</a>
        </li>
        <li
          *ngIf="canShow([roles.ViewReceivable])"
          [routerLinkActive]="['active']"
          [routerLink]="['/monitor-recebiveis']"
        >
          <a>Monitor CISA - Ordens</a>
        </li>
        <li
          *ngIf="canShow([roles.ViewReceivable])"
          [routerLinkActive]="['active']"
          [routerLink]="['/monitor-arquivos']"
        >
          <a>Monitor CISA - Arquivos</a>
        </li>
      </ul>

      <li
        *ngIf="canCreateAny()"
        data-bs-toggle="collapse"
        href="#products"
        [routerLinkActive]="['active']"
        class="collapsed"
      >
        <a>
          <fa-icon [icon]="faGift"></fa-icon> Boletas <span class=""></span>
        </a>
      </li>
      <ul class="sub-menu collapse" id="products">
        <li
          *ngIf="canShow([roles.CreateTicketFundQuota])"
          [routerLinkActive]="['active']"
          [routerLink]="['/quota']"
        >
          <a data-cy="link-quota">Cota</a>
        </li>
        <li
          *ngIf="canShow([roles.CreateTicketPrivateFixedIncome])"
          [routerLinkActive]="['active']"
          [routerLink]="['/cetip']"
        >
          <a>RF - Título Privado</a>
        </li>
        <li
          *ngIf="canShow([roles.CreateTicketPublicFixedIncome])"
          [routerLinkActive]="['active']"
          [routerLink]="['/selic']"
        >
          <a>RF - Título Público </a>
        </li>
        <li
          *ngIf="canShow([roles.CreateTicketFutures])"
          [routerLinkActive]="['active']"
          [routerLink]="['/futures']"
        >
          <a>Futuros</a>
        </li>
        <li
          *ngIf="canShow([roles.CreateTicketMargin])"
          [routerLinkActive]="['active']"
          [routerLink]="['/margin']"
        >
          <a>Margem</a>
        </li>
        <li
          *ngIf="canShow([roles.CreateTicketContracted])"
          [routerLinkActive]="['active']"
          [routerLink]="['/contracted']"
        >
          <a>Compromissada de Compra</a>
        </li>
        <li
          *ngIf="canShow([roles.CreateTicketCurrencyTerm])"
          [routerLinkActive]="['active']"
          [routerLink]="['/currency-term']"
        >
          <a>Termo de Moeda</a>
        </li>
        <li
          *ngIf="canShow([roles.CreateTicketVariableIncome])"
          [hidden]="true"
          [routerLinkActive]="['active']"
          [routerLink]="['/rv']"
        >
          <a>Renda Variável</a>
        </li>
        <li
          *ngIf="canShow([roles.CreateTicketSwapCetip])"
          [routerLinkActive]="['active']"
          [routerLink]="['/swap-cetip']"
        >
          <a>Swap-CETIP</a>
        </li>
        <li
          *ngIf="canShow([roles.CreateTicketTransfer])"
          [routerLinkActive]="['active']"
          [routerLink]="['/transfer']"
        >
          <a>Transferência</a>
        </li>
        <li
          *ngIf="canShow([roles.CreateTicketLoan])"
          [routerLinkActive]="['active']"
          [routerLink]="['/loan']"
        >
          <a>Empréstimo</a>
        </li>
        <li
          *ngIf="canShow([roles.CreateTicketExchange])"
          [routerLinkActive]="['active']"
          [routerLink]="['/exchange']"
        >
          <a>Câmbio</a>
        </li>
        <li
          *ngIf="canShow([roles.CreateExpensesTicket])"
          [routerLinkActive]="['active']"
          [routerLink]="['/expenses']"
        >
          <a>Despesas</a>
        </li>
        <li
          *ngIf="canShow([roles.CreateLiabilitiesTicket])"
          [routerLinkActive]="['active']"
          [routerLink]="['/liabilities']"
        >
          <a>Passivo</a>
        </li>
        <li
          *ngIf="canShow([roles.CreateTicketStructuredOperations])"
          [routerLinkActive]="['active']"
          [routerLink]="['/structured']"
        >
          <a>Operações Estruturadas</a>
        </li>
      </ul>

      <li
        *ngIf="
          canShow([roles.CreateTicketVariableIncome]) || canShowUploadTransfer()
        "
        data-bs-toggle="collapse"
        href="#uploads"
        class="collapsed"
      >
        <a>
          <fa-icon [icon]="faUpload"></fa-icon> Uploads <span class=""></span>
        </a>
      </li>
      <ul class="sub-menu collapse" id="uploads">
        <li
          *ngIf="canShow([roles.CreateTicketVariableIncome])"
          [routerLinkActive]="['active']"
          [routerLink]="['/uploads/pesc']"
        >
          <a>Upload PESC</a>
        </li>
        <li
          *ngIf="canShow([roles.GestorCreateTicket])"
          [routerLinkActive]="['active']"
          [routerLink]="['/uploads/ticket']"
        >
          <a>Upload de Boletas</a>
        </li>
        <!-- <li *ngIf="canShowUploadTransfer()" [routerLinkActive]="['active']" [routerLink]="['/uploads/to']">
          <a>Upload de Ordens de transferência</a>
        </li> -->
      </ul>

      <li
        *ngIf="canShow([roles.AdminCreateLoad])"
        data-bs-toggle="collapse"
        href="#load"
        class="collapsed"
      >
        <a>
          <fa-icon [icon]="faTruck"></fa-icon> Cargas <span class=""></span>
        </a>
      </li>
      <ul class="sub-menu collapse" id="load">
        <li
          *ngIf="canShow([roles.AdminCreateLoad])"
          [routerLinkActive]="['active']"
          [routerLink]="['/uploads/carga']"
        >
          <a>Upload de Carga</a>
        </li>
        <!-- <li *ngIf="canShowUploadTransfer()" [routerLinkActive]="['active']" [routerLink]="['/uploads/to']">
          <a>Upload de Ordens de transferência</a>
        </li> -->
        <li
          *ngIf="canShow([roles.AdminCreateLoad])"
          [routerLinkActive]="['active']"
          [routerLink]="['/obter-cargas']"
        >
          <a>Obter Cargas</a>
        </li>
      </ul>

      <li
        *ngIf="canShowSecurity()"
        data-bs-toggle="collapse"
        href="#cadastro"
        class="collapsed"
      >
        <a>
          <fa-icon [icon]="faLock"></fa-icon> Segurança <span class=""></span>
        </a>
      </li>
      <ul class="sub-menu collapse" id="cadastro" *ngIf="canShowSecurity()">
        <li
          *ngIf="canShow([roles.CreateMasterUser, roles.CreateSubordinateUser])"
          [routerLinkActive]="['active']"
          [routerLink]="['/usuarios']"
        >
          <a>Usuários</a>
        </li>
        <li
          [routerLinkActive]="['active']"
          *ngIf="canShow([roles.ViewCountarpart])"
          [routerLink]="['/counterpart']"
        >
          <a>Contraparte</a>
        </li>
        <li
          *ngIf="canShow([roles.CreateMasterUser])"
          [routerLinkActive]="['active']"
          [routerLink]="['/grupos']"
        >
          <a>Grupos</a>
        </li>
        <li
          *ngIf="canChangeCutoff()"
          [routerLinkActive]="['active']"
          [routerLink]="['/cutoff']"
        >
          <a>Cutoff</a>
        </li>
        <li
          *ngIf="canShow([roles.AdminCreateLoad])"
          [routerLinkActive]="['active']"
          [routerLink]="['/calendario']"
        >
          <a>Calendário</a>
        </li>
      </ul>
    </ul>
  </nav>
  <div class="menu-list">
    <ul>
      <li [routerLinkActive]="['active']" [routerLink]="['/releases']">
        <a> <fa-icon [icon]="faStickyNote"></fa-icon>Releases </a>
      </li>
    </ul>
  </div>
</div>
